import React from 'react';
import { Body } from '@sumup-oss/circuit-ui';
import { useTranslation } from 'next-i18next';

import {
  BannerButton,
  BannerHeadline,
  BannerIcon,
  BannerLeft,
  DTSBannerContainer,
} from '../styled';

import CardTroubleshooting from 'assets/icons/CardTroubleshooting';

const Component = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <DTSBannerContainer>
      <BannerLeft>
        <BannerHeadline as="h3" size="three">
          {t('dts_banner.title')}
        </BannerHeadline>
        <Body>{t('dts_banner.description')}</Body>
        <BannerButton
          variant="primary"
          href="https://me.sumup.com/support/device-troubleshooting?referrer=customer_support_centre"
          target="_blank"
        >
          {t('dts_banner.button')}
        </BannerButton>
      </BannerLeft>
      <BannerIcon>
        <CardTroubleshooting />
      </BannerIcon>
    </DTSBannerContainer>
  );
};

export default Component;
